import { getLocale } from "../runtime";

const sv_trackordertrackanother = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Spåra en annan order`
};

const trackordertrackanother = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackordertrackanother(inputs)
	return "trackOrderTrackAnother";
};

export { trackordertrackanother as "trackOrderTrackAnother" };